export default "__VITE_ASSET__65d4b51a__"